/** Same-app relative path + optional query; rejects open-redirect patterns. */
export function sanitize_next_for_redirect(raw: string | null | undefined): string | null {
  if (raw == null) {
    return null
  }
  const n = raw.trim()
  if (!n.startsWith("/") || n.startsWith("//")) {
    return null
  }
  if (n.includes("://") || n.includes("\\") || n.includes("@")) {
    return null
  }
  for (let i = 0; i < n.length; i++) {
    if (n.charCodeAt(i) < 32) {
      return null
    }
  }
  return n
}
